import * as React from 'react';
import classnames from 'classnames';

import { t } from 'utils/language';
import { sanitizeGenericHtml } from 'utils/sanitize';

type Props = {
  stepIndex: number,
  active: boolean | undefined | null,
  className: string,
  title: string,
  message: string
};

class CampaignTutorialStep extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { stepIndex, active, className, title, message } = this.props;
    const classNames = classnames({
      [className]: true,
      'campaign-tutorial-step': true
    });

    return (
      <div className={classNames}>
        <div className="campaign-tutorial-step__title">
          <span>{String(stepIndex)}. </span>
          {title}
          {
            active && (
              <span className="campaign-tutorial-step__active-indicator">
                {t('campaign_tutorial.active_step_indicator')}
              </span>
            )
          }
        </div>
        <div
          className="campaign-tutorial-step__message"
          dangerouslySetInnerHTML={{ __html: sanitizeGenericHtml(message) }}
        />
      </div>
    );
  }
}

export default CampaignTutorialStep;
